module.exports = __webpack_public_path__ + "static/3-03660c797dd7648c446cff1873bf96f9.jpeg";